import type { settingsFr } from './fr';

/** مفاتيح منطقة الإعدادات (العربية). */
export const settingsAr: Record<keyof typeof settingsFr, string> = {
  'settings.title': 'الإعدادات',
  'settings.subtitle': 'المؤسسة، العلامة البيضاء، التكاملات، مفاتيح API، الوصفات وقاعدة المعرفة.',
  'settings.tab.organization': 'المؤسسة',
  'settings.tab.whitelabel': 'العلامة البيضاء',
  'settings.tab.integrations': 'التكاملات',
  'settings.tab.apikeys': 'مفاتيح API',
  'settings.tab.recipes': 'الوصفات',
  'settings.tab.knowledge': 'قاعدة المعرفة',
  'settings.tab.danger': 'منطقة الخطر',
  'settings.save': 'حفظ',
  'settings.saved': 'تم حفظ التعديلات',
  'settings.savedPartial': 'لا يدعم الخادم هذه الإعدادات كليًا أو جزئيًا بعد: تبقى دون تغيير.',
  'settings.reset': 'إلغاء التعديلات',
  'settings.cancel': 'إلغاء',
  'settings.close': 'إغلاق',
  'settings.actions': 'الإجراءات',
  'settings.readOnly': 'يمكنك الاطلاع على هذه الإعدادات لكن دورك لا يسمح بتعديلها.',
  'settings.error.generic': 'فشلت العملية. أعد المحاولة.',

  'settings.secret.once': 'انسخ هذا السر الآن: لن يُعرض مرة أخرى أبدًا. إذا فقدته فعليك إنشاء سر جديد.',
  'settings.secret.copy': 'نسخ',
  'settings.secret.copiedShort': 'تم النسخ',
  'settings.secret.copied': 'تم النسخ إلى الحافظة',
  'settings.secret.copyFailed': 'تعذّر النسخ: حدّد النص يدويًا.',
  'settings.secret.done': 'لقد نسخت السر، إغلاق',

  'settings.org.title': 'المؤسسة',
  'settings.org.desc': 'الهوية، المنطقة الزمنية، اللغة الافتراضية، الاحتفاظ بالبيانات ومنطقة التخزين.',
  'settings.org.name': 'اسم المؤسسة',
  'settings.org.nameRequired': 'الاسم مطلوب.',
  'settings.org.domain': 'النطاق',
  'settings.org.domainHint': 'نطاق البريد الإلكتروني للمؤسسة (مثل tassili.dz).',
  'settings.org.domainInvalid': 'نطاق غير صالح (مثل example.com).',
  'settings.org.timezone': 'المنطقة الزمنية',
  'settings.org.locale': 'اللغة الافتراضية',
  'settings.org.localeHint': 'تُطبَّق على الأعضاء الجدد.',
  'settings.org.auditRetention': 'مدة الاحتفاظ بسجل التدقيق',
  'settings.org.auditRetentionHint': 'تُحذف الأحداث الأقدم نهائيًا.',
  'settings.org.recordingRetention': 'مدة الاحتفاظ بتسجيلات الجلسات',
  'settings.org.recordingRetentionHint': 'تُشفَّر التسجيلات ثم تُحذف عند انتهاء المدة.',
  'settings.org.days': '{count} يومًا',
  'settings.org.region': 'منطقة تخزين البيانات',
  'settings.org.regionHint': 'مكان استضافة السجلات والتسجيلات والمستندات.',
  'settings.org.region.eu': 'أوروبا (فرانكفورت)',
  'settings.org.region.mena': 'شمال أفريقيا / الشرق الأوسط (الجزائر)',
  'settings.org.regionConfirmTitle': 'تغيير منطقة التخزين؟',
  'settings.org.regionConfirmDesc': 'ستُنقل بيانات المؤسسة إلى «{region}». قد تستغرق العملية عدة ساعات وتُسجَّل في سجل التدقيق.',
  'settings.org.regionConfirm': 'نقل البيانات',

  'settings.wl.title': 'العلامة البيضاء',
  'settings.wl.desc': 'الشعار والألوان والنطاق المخصص للوحة التحكم لعملائك.',
  'settings.wl.enable': 'تفعيل العلامة البيضاء',
  'settings.wl.enableDesc': 'تستبدل هوية سراج بهويتك في لوحة التحكم والرسائل الإلكترونية.',
  'settings.wl.logo': 'الشعار',
  'settings.wl.logoAlt': 'شعار المؤسسة',
  'settings.wl.noLogo': 'لا يوجد شعار',
  'settings.wl.logoUpload': 'اختيار شعار',
  'settings.wl.logoRemove': 'إزالة',
  'settings.wl.logoHint': 'PNG أو JPEG أو SVG أو WebP، بحد أقصى {max} كيلوبايت.',
  'settings.wl.logoType': 'صيغة غير مدعومة: استخدم PNG أو JPEG أو SVG أو WebP.',
  'settings.wl.logoSize': 'الملف كبير جدًا (الحد الأقصى {max} كيلوبايت).',
  'settings.wl.logoRead': 'تعذّرت قراءة هذا الملف.',
  'settings.wl.primary': 'اللون الأساسي',
  'settings.wl.primaryHint': 'الشريط الجانبي والصور الرمزية؛ نص أبيض فوقه.',
  'settings.wl.accent': 'لون التمييز',
  'settings.wl.accentHint': 'الأزرار والعناصر النشطة.',
  'settings.wl.picker': 'منتقي الألوان: {label}',
  'settings.wl.hexInvalid': 'رمز سداسي عشري غير صالح (مثل #0F1623).',
  'settings.wl.contrast.title': 'فحص التباين (WCAG AA)',
  'settings.wl.contrast.primary': 'نص أبيض على اللون الأساسي',
  'settings.wl.contrast.accent': 'النص على لون التمييز',
  'settings.wl.contrast.pass': 'مطابق',
  'settings.wl.contrast.fail': 'غير كافٍ',
  'settings.wl.contrast.primaryFail': 'تباين النص الأبيض أقل من {min}:1: اللون الأساسي فاتح جدًا ولا يمكن قراءته بوضوح.',
  'settings.wl.contrast.fix': 'تصحيح تلقائي',
  'settings.wl.domain': 'النطاق المخصص',
  'settings.wl.domainHint': 'عنوان لوحة التحكم لعملائك (مثل console.example.com).',
  'settings.wl.preview': 'معاينة مباشرة',
  'settings.wl.previewDesc': 'لوحة التحكم بألوان علامتك.',
  'settings.wl.previewAlt': 'معاينة لوحة التحكم بالشعار والألوان المختارة',
  'settings.wl.previewButton': 'جلسة جديدة',
  'settings.wl.previewDisabled': 'العلامة البيضاء معطّلة: هذه المعاينة غير مطبّقة بعد.',
  'settings.wl.dns.title': 'التحقق من النطاق',
  'settings.wl.dns.desc': 'أثبت ملكيتك للنطاق بسجل DNS.',
  'settings.wl.dns.none': 'احفظ نطاقًا مخصصًا للحصول على سجل DNS المطلوب إنشاؤه.',
  'settings.wl.dns.instructions': 'أضف سجل TXT هذا لدى مزوّد DNS للنطاق {domain}، ثم شغّل التحقق.',
  'settings.wl.dns.type': 'النوع',
  'settings.wl.dns.host': 'الاسم',
  'settings.wl.dns.value': 'القيمة',
  'settings.wl.dns.copy': 'نسخ القيمة',
  'settings.wl.dns.check': 'تحقق الآن',
  'settings.wl.dns.verified': 'تم التحقق',
  'settings.wl.dns.pending': 'قيد الانتظار',
  'settings.wl.dns.saveFirst': 'احفظ النطاق الجديد قبل التحقق منه.',
  'settings.wl.dns.lastCheck': 'آخر تحقق: {date}. قد يستغرق انتشار DNS بضع دقائق.',
  'settings.wl.dns.verifiedToast': 'تم التحقق من النطاق',
  'settings.wl.dns.pendingToast': 'سجل DNS غير موجود حاليًا: أعد المحاولة بعد قليل.',

  'settings.int.title': 'التذاكر',
  'settings.int.desc': 'أرفق تقرير الجلسة تلقائيًا بالتذكرة في أداة الدعم لديك.',
  'settings.int.desc.freshdesk': 'تقرير الجلسة مرفق بتذكرة Freshdesk',
  'settings.int.desc.zendesk': 'تقرير الجلسة مرفق بتذكرة Zendesk',
  'settings.int.desc.glpi': 'تقرير الجلسة مرفق بتذكرة GLPI',
  'settings.int.desc.jira_sm': 'تقرير الجلسة مرفق بطلب Jira Service Management',
  'settings.int.status.connected': 'متصل',
  'settings.int.status.disconnected': 'غير متصل',
  'settings.int.status.error': 'خطأ',
  'settings.int.connectedSince': 'متصل {date}',
  'settings.int.notConnected': 'لم يتم الاتصال بعد',
  'settings.int.testOk': 'نجح آخر اختبار ({ms} م.ث)',
  'settings.int.testFailed': 'فشل آخر اختبار',
  'settings.int.testFirst': 'اختبر الاتصال قبل تفعيل التكامل.',
  'settings.int.configure': 'إعداد',
  'settings.int.view': 'عرض',
  'settings.int.connect': 'اتصال',
  'settings.int.disconnect': 'قطع الاتصال',
  'settings.int.connectedToast': 'تم الاتصال بـ {name}',
  'settings.int.disconnectedToast': 'تم قطع الاتصال بـ {name}',
  'settings.int.drawerDesc': 'الوصول إلى الخدمة واختبار الاتصال وربط الحقول.',
  'settings.int.baseUrl': 'عنوان الخدمة',
  'settings.int.baseUrlHint': 'عنوان HTTPS لنسختك.',
  'settings.int.urlInvalid': 'يجب أن يبدأ العنوان بـ https://.',
  'settings.int.account': 'حساب الخدمة',
  'settings.int.secret': 'الرمز أو مفتاح API',
  'settings.int.secretHint': 'يُخزَّن مشفّرًا ولا يُعرض مرة أخرى.',
  'settings.int.secretKeep': 'يوجد رمز محفوظ. اتركه فارغًا للإبقاء عليه.',
  'settings.int.attach': 'إرفاق تقرير الجلسة',
  'settings.int.attachDesc': 'يضيف التقرير إلى التذكرة تلقائيًا عند انتهاء الجلسة.',
  'settings.int.mapping': 'ربط الحقول',
  'settings.int.mappingDesc': 'حقل التذكرة الذي يستقبل كل معلومة من التقرير.',
  'settings.int.mappingFor': 'حقل التذكرة لـ: {field}',
  'settings.int.field.subject': 'الموضوع',
  'settings.int.field.description': 'الوصف',
  'settings.int.field.technician': 'الفني',
  'settings.int.field.duration': 'المدة',
  'settings.int.field.summary': 'ملخص الذكاء الاصطناعي',
  'settings.int.field.device': 'الجهاز',
  'settings.int.field.rating': 'التقييم',
  'settings.int.test': 'اختبار الاتصال',
  'settings.int.saveBeforeTest': 'احفظ تعديلاتك قبل الاختبار.',
  'settings.int.testOkLong': 'نجح الاتصال ({ms} م.ث).',
  'settings.int.testError.ok': 'نجح الاتصال.',
  'settings.int.testError.invalid_url': 'عنوان غير صالح: يلزم عنوان HTTPS.',
  'settings.int.testError.unauthorized': 'تم رفض الوصول: تحقق من الحساب والرمز.',
  'settings.int.testError.unreachable': 'تعذّر الوصول إلى الخدمة: تحقق من العنوان والشبكة.',

  'settings.wh.title': 'الويب هوك الصادر',
  'settings.wh.desc': 'استقبل أحداث سراج في أنظمتك. كل إرسال موقَّع (HMAC-SHA256) بسر الويب هوك.',
  'settings.wh.add': 'إضافة ويب هوك',
  'settings.wh.addDesc': 'سيرسل سراج طلب POST موقَّعًا إلى هذا العنوان.',
  'settings.wh.create': 'إنشاء الويب هوك',
  'settings.wh.url': 'عنوان الوجهة',
  'settings.wh.urlInvalid': 'يجب أن يبدأ العنوان بـ https://.',
  'settings.wh.events': 'الأحداث',
  'settings.wh.enabled': 'نشط',
  'settings.wh.toggle': 'تفعيل أو تعطيل الويب هوك {url}',
  'settings.wh.last': 'آخر إرسال',
  'settings.wh.never': 'أبدًا',
  'settings.wh.empty': 'لا يوجد ويب هوك مُعدّ.',
  'settings.wh.secretHint': 'سر ينتهي بـ {hint}',
  'settings.wh.secretTitle': 'سر توقيع الويب هوك',
  'settings.wh.secretDesc': 'استخدمه للتحقق من توقيع الطلبات الواردة.',
  'settings.wh.rotate': 'تجديد السر',
  'settings.wh.rotateTitle': 'تجديد السر؟',
  'settings.wh.rotateDesc': 'يتوقف السر القديم عن العمل فورًا. حدّث المستقبِل بالسر الجديد.',
  'settings.wh.delete': 'حذف الويب هوك',
  'settings.wh.deleteTitle': 'حذف هذا الويب هوك؟',
  'settings.wh.deleted': 'تم حذف الويب هوك',
  'settings.wh.deliveries': 'سجل الإرسال',
  'settings.wh.noDeliveries': 'لا توجد عمليات إرسال بعد.',
  'settings.wh.date': 'التاريخ',
  'settings.wh.event': 'الحدث',
  'settings.wh.result': 'النتيجة',
  'settings.wh.attempt': 'المحاولة',
  'settings.wh.status.success': 'نجح',
  'settings.wh.status.failed': 'فشل',
  'settings.wh.replay': 'إعادة إرسال هذه العملية',
  'settings.wh.replayed': 'تمت إعادة الإرسال',

  'settings.keys.title': 'مفاتيح API',
  'settings.keys.desc': 'وصول برمجي إلى واجهة سراج. لكل مفتاح نطاقاته الخاصة ويمكن أن تنتهي صلاحيته.',
  'settings.keys.create': 'إنشاء مفتاح',
  'settings.keys.createDesc': 'اقصر المفتاح على النطاقات اللازمة فقط.',
  'settings.keys.generate': 'توليد المفتاح',
  'settings.keys.name': 'الاسم',
  'settings.keys.namePlaceholder': 'مثال: تصدير BI الليلي',
  'settings.keys.expiry': 'انتهاء الصلاحية',
  'settings.keys.expiryDays': '{count} يومًا',
  'settings.keys.expiryNever': 'أبدًا',
  'settings.keys.scopes': 'النطاقات',
  'settings.keys.scopesHint': 'اختر نطاقًا واحدًا على الأقل. لا يمكن للمفتاح تجاوز صلاحياتك.',
  'settings.keys.presetRead': 'قراءة فقط',
  'settings.keys.presetNone': 'إلغاء تحديد الكل',
  'settings.keys.created': 'تاريخ الإنشاء',
  'settings.keys.lastUsed': 'آخر استخدام',
  'settings.keys.neverUsed': 'لم يُستخدم أبدًا',
  'settings.keys.expires': 'ينتهي',
  'settings.keys.noExpiry': 'بلا انتهاء',
  'settings.keys.expired': 'منتهي',
  'settings.keys.empty': 'لا توجد مفاتيح API',
  'settings.keys.emptyDesc': 'أنشئ مفتاحًا لربط سراج بأدواتك.',
  'settings.keys.secretTitle': 'مفتاح API الجديد',
  'settings.keys.secretDesc': 'يمنح الوصول إلى مؤسستك وفق نطاقاته.',
  'settings.keys.revoke': 'إلغاء',
  'settings.keys.revokeNamed': 'إلغاء المفتاح {name}',
  'settings.keys.revokeTitle': 'إلغاء هذا المفتاح؟',
  'settings.keys.revokeDesc': 'ستفقد التطبيقات التي تستخدم «{name}» الوصول فورًا. لا يمكن التراجع عن هذا الإجراء.',
  'settings.keys.revoked': 'تم إلغاء المفتاح',

  'settings.rcp.title': 'وصفات المؤسسة',
  'settings.rcp.desc': 'إجراءات استكشاف أخطاء قابلة لإعادة الاستخدام: موافقة وتوقيع ثم نشر تدريجي على الأجهزة.',
  'settings.rcp.mine': 'وصفاتي',
  'settings.rcp.library': 'المكتبة الرسمية',
  'settings.rcp.official': 'رسمية',
  'settings.rcp.new': 'وصفة جديدة',
  'settings.rcp.edit': 'تعديل',
  'settings.rcp.editSignedNote': 'هذه الوصفة موقَّعة: تعديلها ينشئ إصدارًا جديدًا يجب اعتماده من جديد.',
  'settings.rcp.name': 'الاسم',
  'settings.rcp.description': 'الوصف',
  'settings.rcp.steps': 'الخطوات',
  'settings.rcp.stepsHint': 'خطوة واحدة في كل سطر.',
  'settings.rcp.status.draft': 'مسودة',
  'settings.rcp.status.pending_approval': 'بانتظار الموافقة',
  'settings.rcp.status.signed': 'موقَّعة',
  'settings.rcp.meta': 'بواسطة {author} · حُدّثت في {date}',
  'settings.rcp.signature': 'التوقيع {sig}…',
  'settings.rcp.approvedBy': 'اعتمدها {name}',
  'settings.rcp.submit': 'إرسال للموافقة',
  'settings.rcp.submitted': 'أُرسلت الوصفة للموافقة',
  'settings.rcp.approve': 'اعتماد وتوقيع',
  'settings.rcp.signed': 'تم توقيع الوصفة',
  'settings.rcp.reject': 'إعادتها إلى مسودة',
  'settings.rcp.rejected': 'أُعيدت الوصفة إلى مسودة',
  'settings.rcp.deploy': 'نشر',
  'settings.rcp.delete': 'حذف',
  'settings.rcp.deleteTitle': 'حذف هذه الوصفة؟',
  'settings.rcp.deleted': 'تم حذف الوصفة',
  'settings.rcp.import': 'إضافة إلى مؤسستي',
  'settings.rcp.imported': 'أُضيفت الوصفة كمسودة',
  'settings.rcp.empty': 'لا توجد وصفات',
  'settings.rcp.emptyDesc': 'أنشئ وصفة أو استورد واحدة من المكتبة الرسمية.',
  'settings.rcp.rollout.title': 'النشر التدريجي',
  'settings.rcp.rollout.stages': 'مراحل النشر',
  'settings.rcp.rollout.machines': '{count} جهاز',
  'settings.rcp.rollout.failures': '{failed} إخفاق · {pct}٪',
  'settings.rcp.rollout.next': 'المرحلة التالية',
  'settings.rcp.rollout.pending': 'بالانتظار',
  'settings.rcp.rollout.status.running': 'قيد التنفيذ',
  'settings.rcp.rollout.status.halted': 'متوقف',
  'settings.rcp.rollout.status.completed': 'مكتمل',
  'settings.rcp.rollout.thresholdLabel': 'حد الإخفاق (٪)',
  'settings.rcp.rollout.thresholdInvalid': 'بين 0 و100.',
  'settings.rcp.rollout.threshold': 'إيقاف تلقائي إذا فشل أكثر من {pct}٪ من أجهزة المرحلة.',
  'settings.rcp.rollout.start': 'بدء (جهاز واحد)',
  'settings.rcp.rollout.restart': 'إعادة تشغيل النشر',
  'settings.rcp.rollout.advance': 'الانتقال إلى المرحلة التالية',
  'settings.rcp.rollout.halt': 'إيقاف',
  'settings.rcp.rollout.autoHalted': 'إيقاف تلقائي: {pct}٪ إخفاق، أعلى من حد {threshold}٪. لن يستمر النشر.',
  'settings.rcp.rollout.autoHaltedToast': 'أُوقف النشر تلقائيًا: تم تجاوز حد الإخفاق',
  'settings.rcp.rollout.manualHalted': 'أُوقف النشر يدويًا.',
  'settings.rcp.rollout.completed': 'اكتمل النشر في جميع المراحل.',
  'settings.rcp.rollout.completedToast': 'اكتمل النشر',

  'settings.kb.title': 'قاعدة المعرفة',
  'settings.kb.desc': 'مستندات شركتك التي يرجع إليها المساعد الذكي للإجابة (RAG). تبقى خاصة بمؤسستك.',
  'settings.kb.drop': 'اسحب مستنداتك إلى هنا',
  'settings.kb.formats': 'الصيغ: {formats} · بحد أقصى {max} ميغابايت للملف',
  'settings.kb.add': 'إضافة مستندات',
  'settings.kb.added': 'أُضيف «{name}»، الفهرسة جارية',
  'settings.kb.unsupported': '«{name}»: صيغة غير مدعومة.',
  'settings.kb.tooLarge': '«{name}» يتجاوز {max} ميغابايت.',
  'settings.kb.name': 'المستند',
  'settings.kb.status': 'الفهرسة',
  'settings.kb.status.queued': 'في الانتظار',
  'settings.kb.status.indexing': 'قيد الفهرسة',
  'settings.kb.status.indexed': 'مفهرس',
  'settings.kb.status.failed': 'فشل',
  'settings.kb.error.unsupported_type': 'صيغة غير مدعومة',
  'settings.kb.error.too_large': 'الملف كبير جدًا',
  'settings.kb.error.extraction_failed': 'تعذّر استخراج النص (مسح ضوئي أو ملف محمي)',
  'settings.kb.chunks': 'المقاطع',
  'settings.kb.added.col': 'أُضيف',
  'settings.kb.retry': 'إعادة فهرسة {name}',
  'settings.kb.delete': 'حذف {name}',
  'settings.kb.deleteTitle': 'حذف هذا المستند؟',
  'settings.kb.deleteDesc': 'سيُزال «{name}» من الفهرس ولن يستخدمه المساعد بعد الآن.',
  'settings.kb.deleteConfirm': 'حذف',
  'settings.kb.deleted': 'تم حذف المستند',
  'settings.kb.empty': 'لا توجد مستندات',
  'settings.kb.emptyDesc': 'أضف إجراءات أو سياسات أو أدلة لإثراء إجابات المساعد.',
  'settings.kb.statDocs': 'المستندات',
  'settings.kb.statInProgress': '{count} قيد الفهرسة',
  'settings.kb.statChunks': 'المقاطع المفهرسة',
  'settings.kb.statChunksHint': 'متاحة للمساعد',
  'settings.kb.kb': 'ك.ب',
  'settings.kb.mb': 'م.ب',

  'settings.danger.exportTitle': 'تصدير البيانات',
  'settings.danger.exportDesc': 'نزّل تصدير JSON للمؤسسة (الإعدادات والأعضاء والأجهزة والسياسات والجلسات وسجل التدقيق).',
  'settings.danger.export': 'تصدير البيانات',
  'settings.danger.exported': 'تم تنزيل التصدير',
  'settings.danger.noExport': 'يتطلب التصدير صلاحيتي إدارة الإعدادات وتصدير التدقيق.',
  'settings.danger.deleteTitle': 'حذف المؤسسة',
  'settings.danger.deleteDesc': 'يحذف المؤسسة وجميع بياناتها نهائيًا. فكّر في تصدير بياناتك قبل ذلك.',
  'settings.danger.delete': 'حذف المؤسسة',
  'settings.danger.ownerOnly': 'مالك المؤسسة وحده يمكنه حذفها.',
  'settings.danger.step1Title': 'حذف المؤسسة؟',
  'settings.danger.step1Warning': 'لا يمكن التراجع عن هذا الإجراء.',
  'settings.danger.consequence1': 'تُحذف الأجهزة والأعضاء والسياسات والسجلات.',
  'settings.danger.consequence2': 'تتوقف مفاتيح API والويب هوك والتكاملات عن العمل.',
  'settings.danger.consequence3': 'يُلغى الاشتراك دون استرداد الشهر الحالي.',
  'settings.danger.understand': 'أدرك أن هذا الحذف نهائي.',
  'settings.danger.continue': 'متابعة',
  'settings.danger.step2Title': 'التأكيد الأخير',
  'settings.danger.step2Desc': 'اكتب اسم المؤسسة بالضبط، «{name}»، للتأكيد.',
  'settings.danger.typeName': 'اسم المؤسسة',
  'settings.danger.confirmDelete': 'حذف نهائي',
  'settings.danger.deleted': 'تم حذف المؤسسة',
  'settings.danger.deleteFailed': 'تعذّر الحذف: تحقق من الاسم المكتوب ومن صلاحياتك.',

  // Écran « Mon profil » (src/features/profile)
  'profile.account': 'الحساب',
  'profile.accountDesc': 'بيانات تسجيل الدخول لحسابك في سراج.',
  'profile.name': 'الاسم',
  'profile.email': 'البريد الإلكتروني',
  'profile.twoFactor': 'المصادقة الثنائية',
  'profile.twoFactorOn': 'مفعّلة',
  'profile.twoFactorOff': 'غير مفعّلة',
  'profile.preferences': 'التفضيلات',
  'profile.preferencesDesc': 'لغة لوحة التحكم ومظهر العرض.',
  'profile.organizations': 'المؤسسات',
  'profile.organizationsDesc': 'المؤسسات المرتبط بها حسابك ودورك في كل منها.',
  'profile.active': 'نشطة',
  'profile.switch': 'تبديل',
};
